let isLoaded = false;

export async function loadModule() {
    if (isLoaded) {
        return;
    }

    const { init } = await import('./init');
    init();

    isLoaded = true;
}
